module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "head"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v("（" + _vm._s(_vm._f("coverPhone")(_vm.subTitle)) + "）")]), _vm._v(" "), (_vm.date) ? _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.date))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f6130152"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/regexp-replace-loader?{"match":{"pattern":"replacing_version","flags":"g"},"replaceWith":"1.0.8"}!./src/commponents/head/index.vue
// module id = 4jwz
// module chunks = 5